import { render, staticRenderFns } from "./SpaceBookingRulesPage.vue?vue&type=template&id=04941c9a&scoped=true"
import script from "./SpaceBookingRulesPage.vue?vue&type=script&lang=ts"
export * from "./SpaceBookingRulesPage.vue?vue&type=script&lang=ts"
import style0 from "./SpaceBookingRulesPage.vue?vue&type=style&index=0&id=04941c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04941c9a",
  null
  
)

export default component.exports